











































































import { Component, Vue } from "vue-property-decorator";
import MyCanvas from "@/components/MyCanvas.vue";
import DropZone from "@/components/DropZone.vue";
import Ruler from "@/components/Ruler.vue";
import RulerModal from "@/components/RulerModal.vue";
import Report from "@/components/Report.vue";
import Point from "@/utils/point";
import { State, adjustSize, Length } from "@/utils/states";
import { AnalysisData, AnalysisResult } from "@/utils/analysis";
import M from "materialize-css";
import { detect } from "detect-browser";

const browser = detect();

@Component({
  components: {
    MyCanvas,
    DropZone,
    Ruler,
    RulerModal,
    Report
  }
})
export default class Home extends Vue {
  private readonly toastDuration = 4000;
  private readonly longToastDuration = 1800000;
  data: AnalysisData = new AnalysisData();
  close = false;
  openModal = false;
  state = State.Upload;
  image: string | null = null;
  result: AnalysisResult | null = null;
  canvasKey = 0;
  safariFix = false;

  setImage(img: string, width: number, height: number) {
    this.image = img;
    this.data.size = adjustSize(
      { width: width, height: height },
      window.innerWidth
    );
    this.state = State.Ruler;
    M.toast({ html: "Mark ruler", displayLength: this.longToastDuration });
    setTimeout(() => {
      if (browser && browser.name === "safari") {
        this.safariFix = true;
      }
    }, 300);
  }

  addNewPoint(point: Point) {
    if (!this.close) {
      this.activeArray.push(point);
    }
  }

  setRuler(ruler: { start: Point; end: Point }) {
    this.data.ruler = ruler;
    this.state = State.Stomach;
    M.Toast.dismissAll();
    M.toast({ html: "Ruler marked", displayLength: this.toastDuration });
    this.openModal = true;
  }

  setRulerLength(length: Length) {
    this.data.rulerRealLength = length;
    this.openModal = false;
    this.toastStomach();
  }

  toastStomach() {
    M.toast({
      html: Home.getToastHtml("Mark stomach outline"),
      displayLength: this.longToastDuration,
      completeCallback: this.undo,
      inDuration: 0,
      outDuration: 0
    });
    Home.subscribeUndo();
  }

  closeOutline() {
    this.close = true;
    M.Toast.dismissAll();
    M.toast({ html: "Outline marked", displayLength: this.toastDuration });
  }

  undo() {
    if (!this.close) {
      this.activeArray.pop();
      this.canvasKey += 1;
      if (this.state === State.Stomach) {
        this.toastStomach();
      } else {
        this.toastCancer();
      }
    }
  }

  startCancerOutline() {
    this.data.addCancerOutline();
    this.state = State.Cancer;
    this.close = false;
    if (this.data.cancerIndex <= 0) {
      this.canvasKey += 1;
    }
    this.toastCancer();
  }

  toastCancer() {
    M.toast({
      html: Home.getToastHtml(
        `Mark cancer outline #${this.data.cancerIndex + 1}`
      ),
      displayLength: this.longToastDuration,
      completeCallback: this.undo,
      inDuration: 0,
      outDuration: 0
    });
    Home.subscribeUndo();
  }

  analyse() {
    const result = this.data.generateReport();
    if (result) {
      this.result = result;
      setTimeout(() => {
        const reportSection = document.getElementsByClassName("report")[0];
        reportSection.scrollIntoView();
      }, 300);
    }
  }

  reset() {
    this.close = true;
    M.Toast.dismissAll();

    this.data = new AnalysisData();
    this.openModal = false;
    this.state = State.Upload;
    this.image = null;
    this.result = null;
    this.canvasKey += 1;
    this.safariFix = false;
    setTimeout(() => {
      this.close = false;
    }, 800);
    setTimeout(() => {
      const reportSection = document.getElementById("app");
      reportSection?.scrollIntoView();
    }, 300);
  }

  static subscribeUndo() {
    setTimeout(() => {
      const buttons = document.getElementsByClassName("btn-undo");
      if (buttons.length > 0) {
        const button = buttons[0];
        button.addEventListener("click", Home.dismissToast);
      }
    }, 200);
  }

  static dismissToast() {
    const toastElement = document.querySelector(".toast");
    if (toastElement) {
      const toastInstance = M.Toast.getInstance(toastElement);
      toastInstance.dismiss();
    }
  }

  static getToastHtml(text: string): string {
    return `<span>${text}</span><button class="btn-flat toast-action btn-undo">Undo</button>`;
  }

  get activeArray() {
    if (this.state === State.Cancer) {
      return this.data.cancerOutline;
    } else {
      return this.data.stomachOutline;
    }
  }

  get analysisPossibility() {
    return this.state === State.Cancer && this.close;
  }

  get closePossibility() {
    return this.close || this.activeArray.length < 3;
  }

  get outlineState() {
    return this.state === State.Stomach || this.state === State.Cancer;
  }

  get rulerState() {
    return this.state === State.Ruler;
  }

  get cancerState() {
    return this.state === State.Cancer;
  }

  get outlineLabel() {
    return this.state === State.Stomach ? "stomach" : "cancer";
  }
}
